export default <ContainerConstD>{
    'widthFix':['height'],
    'heightFix':['width']
}
